export const CONTACT = {
  email: 'info@logitslab.ai',
  phone: '+91 9264941175',
  phoneHref: 'tel:+919264941175',
  emailHref: 'mailto:info@logitslab.ai',
  office: {
    city: 'Noida',
    region: 'Uttar Pradesh',
    country: 'India',
    label: 'Noida, India',
  },
  siteUrl: 'https://logitslab.com',
  siteName: 'LogitsLab',
  /**
   * Lead forms post to Formspree when REACT_APP_FORMSPREE_ID is set in .env
   * (CRA). Without it, forms show an error and point users to info@logitslab.ai.
   */
  formspreeEnv: 'REACT_APP_FORMSPREE_ID',
};
